import type Phaser from 'phaser';
import { TX } from '../registry/keys';

/** Which way the player last faced — used to pick the idle frame. */
export type Facing = 'down' | 'up' | 'side';

/**
 * Play the directional walk animation matching a movement vector (down/up/side,
 * flipping for left). Shared by every scene so the farmer faces the right way
 * everywhere. Falls back to the single 'player-walk' when the real sheet's
 * directional rows aren't present. Returns the new facing.
 */
export function faceMove(scene: Phaser.Scene, player: Phaser.GameObjects.Sprite, dx: number, dy: number): Facing {
  if (player.texture.key === TX.playerAction) player.setTexture(TX.player);
  let key: string;
  let facing: Facing;
  if (Math.abs(dx) > Math.abs(dy)) {
    key = scene.anims.exists('walk-side') ? 'walk-side' : 'player-walk';
    player.setFlipX(dx < 0);
    facing = 'side';
  } else if (dy < 0) {
    key = scene.anims.exists('walk-up') ? 'walk-up' : 'player-walk';
    facing = 'up';
  } else {
    key = scene.anims.exists('walk-down') ? 'walk-down' : 'player-walk';
    facing = 'down';
  }
  if (scene.anims.exists(key) && (player.anims.currentAnim?.key !== key || !player.anims.isPlaying)) {
    player.play(key);
  }
  return facing;
}

/** Stop on the idle frame for the last-faced direction. */
export function faceIdle(scene: Phaser.Scene, player: Phaser.GameObjects.Sprite, facing: Facing): void {
  if (player.texture.key === TX.playerAction) player.setTexture(TX.player);
  player.stop();
  player.setFrame(!scene.anims.exists('walk-up') ? 0 : facing === 'up' ? 4 : facing === 'side' ? 8 : 0);
}
